import Vue from 'vue'
import axios from 'axios'
import {storage} from '@/utils/storage'
import HOST from '@/config/ENV'

const apiInstance = axios.create({
  timeout: 36000
})
// const baseUrl = '/api'
// const baseUrl = '//localhost:8060'
// const baseUrl = 'http://www.hk952183.com:32180/rest'
// const baseUrl = '//118.24.54.72:8060' // 测试环境
const baseUrl = HOST.host
export const testApi = () => createApi(`www.baidu.com`)
export const doLogin = (config) => createApi(`/admin/login`, 'post', config) // 登录
export const logOut = () => createApi(`/logout`) // 退出
export const changePwd = (config) => createApi(`/user/changePwd`, 'post', config) // 修改密码
export const getUserInfoByToken = async (config) => createApi(`/getHkUserInfoWithToken`, 'get', config) // 根据养老系统的token去拿本系统的用户信息

Vue.mixin({
  beforeCreate () {
    const options = this.$options
    if (options.api) {
      this.$api = options.api
    } else if (options.parent && options.parent.$api) {
      this.$api = options.parent.$api
    }
  }
})

apiInstance.interceptors.request.use(
  config => {
    const userinfo = storage.get('userinfo') || {}
    if (config.url.indexOf('admin/login') === -1 && userinfo.token) {
      config.headers['X-Token'] = userinfo.token
      
    }
    const xpage = storage.get('X-Page') || ''
    if( config.url.indexOf('admin/login') === -1 && xpage) {
      config.headers['X-Page'] = xpage
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

apiInstance.interceptors.response.use((res, xhr) => {
  const data = res.data
  if( data && data.code !== '00000000') {
    window.myVue.$message.error(data.message)
  }
  // token过期或解析失败，清除浏览器缓存用户的token
  if (data && data.code === '00001111') {
    storage.set('userinfo', {})
    storage.set('tokenError', true)
    window.myVue.$router.push({ path: '/login' })
  }
  return data
}, (error) => {
  return Promise.reject(error)
})

export const getUrl = (action, config = {}) => {
  config.query = config.query || {}
  action = baseUrl + action
    .replace('{id}', config.query.id)
  return action
}

export const createApi = (action, method = 'get', config = {}) => {
  return apiInstance({
    url: getUrl(action, config),
    withCredentials: false,
    method,
    ...config
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js